import { useState } from 'react';
import { Alert, SearchBar, Pagination } from '@/shared/components';
import { useDealerConfigOptionsQuery } from '../hooks/useDealerConfigOptionsQuery';
import { DealerConfigOptionDataTable } from '../components/DealerConfigOptionDataTable';

export function DealerConfigOptionList() {
  const [search, setSearch] = useState('');
  const [group, setGroup] = useState('');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const resetPage = () => setPage(1);

  const query = useDealerConfigOptionsQuery({
    search: search.length >= 2 ? search : undefined,
    // The dealer catalog's `group` column is free-form (backend groupRule is
    // `nullable|string|max:50`, with no pinned vocabulary — unlike smr's fixed
    // enum), so this is a free-text filter rather than a fixed-enum dropdown.
    group: group.length >= 1 ? group : undefined,
    page,
    per_page: perPage,
  });
  const options = query.data?.data ?? [];
  const meta = query.data?.meta;

  return (
    <section className="space-y-4">
      <h1 className="text-2xl font-semibold">Dealer Config Options</h1>

      <div className="flex gap-2 flex-wrap items-center">
        <SearchBar
          searchTerm={search}
          setSearchTerm={(term) => { setSearch(term); resetPage(); }}
          placeholder="Search config options"
        />
        <SearchBar
          searchTerm={group}
          setSearchTerm={(term) => { setGroup(term); resetPage(); }}
          placeholder="Filter by group"
        />
      </div>

      {query.isError && (
        <Alert variant="error">
          <span>Failed to load the dealer config-options catalog.</span>
        </Alert>
      )}

      <div className="space-y-4">
        <DealerConfigOptionDataTable data={options} isLoading={query.isLoading} />

        {meta && meta.last_page > 1 && (
          <Pagination
            currentPage={meta.current_page}
            lastPage={meta.last_page}
            total={meta.total}
            perPage={meta.per_page}
            from={meta.from}
            to={meta.to}
            onPageChange={setPage}
            onPerPageChange={(n) => { setPerPage(n); setPage(1); }}
          />
        )}
      </div>
    </section>
  );
}
